import { Briefcase, Camera, Mic2, type LucideIcon } from 'lucide-react';
import type { Tool, ToolId } from '@portal/shared';

export const TOOL_ICONS: Record<Tool['iconKey'], LucideIcon> = {
  briefcase: Briefcase,
  mic2: Mic2,
  camera: Camera,
};

/**
 * The MVP tool registry. Order here drives display order on the dashboard.
 */
export const TOOLS: Tool[] = [
  {
    id: 'jobs',
    name: 'Jobs',
    description: 'Track inspections, items, and pricing per appraisal job.',
    iconKey: 'briefcase',
    pathSegment: 'jobs',
    status: 'stable',
    futureCapabilities: [
      'Create jobs with business + bank metadata',
      'Per-job item list with inline pricing + photos',
      'Excel export of the final asset listing',
    ],
  },
  {
    id: 'stt',
    name: 'Quick transcribe',
    // Standalone dictation page kept for ad-hoc transcriptions that don't
    // belong to a job. Greg's main dictation flow lives inline on the job
    // detail page (Dictation card), so this tile is hidden from the
    // dashboard — the route still works for power users / direct links.
    description: 'One-off audio → Excel (no job).',
    iconKey: 'mic2',
    pathSegment: 'stt',
    status: 'stable',
    hiddenFromDashboard: true,
    futureCapabilities: [
      'Drop in inspection audio (mp3/wav/m4a)',
      'Greg-style line items (qty, description, sheetType)',
      'Leasehold logic + automatic separator rows',
    ],
  },
];

export function getTool(id: ToolId): Tool | undefined {
  return TOOLS.find((t) => t.id === id);
}
